import EventHandler from '../../events/event_handler';
import ImportedModalEvents from './modal_events';

export const ModalEvents = ImportedModalEvents;
export const ModalEventHandler = new EventHandler(Object.values(ModalEvents));

export default ModalEventHandler;
